import { colornames } from "color-name-list";
import { Select } from "antd";
import PropTypes from "prop-types";

const SelectColor = ({ selectedColor, setSelectedColor, t }) => {
    const colorOptions = colornames.map((color) => ({
        value: color.name,
        label: (
            <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full border border-gray-200" style={{ backgroundColor: color.hex }} />
                <span>{color.name}</span>
            </div>
        ),
    }));

    const handleColorChange = (value) => {
        setSelectedColor(value);
    };

    return (
        <div>
            <p className="text-md font-medium mb-2">
                {t("car")} {t("color")}
            </p>
            <Select
                showSearch
                placeholder={t("searchForColor")}
                optionFilterProp="children"
                onChange={handleColorChange}
                value={selectedColor || undefined}
                className="w-full"
                options={colorOptions}
                filterOption={(input, option) => (option?.value ?? "").toLowerCase().includes(input.toLowerCase())}
            />
        </div>
    );
};

SelectColor.propTypes = {
    selectedColor: PropTypes.string.isRequired,
    setSelectedColor: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default SelectColor;
